/**
 * Created by andrey on 04.07.17.
 */

const CrossPromoWindow = CleverappsWindow.extend({
    onWindowLoaded: function (promotions) {
        this.promotions = promotions;
        const content = this.createContent();
        this.wideMode = cleverapps.resolution.mode;
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PROMO_SHOW);

        this._super({
            title: Messages.get("CrossPromo.title"),
            name: "crosspromowindow",
            content,
            styles: cleverapps.styles.CrossPromoWindow.window
        });
    },

    getLoadingTasks: function (promotions) {
        return [(onSuccess) => {
            this.loadImages(promotions, onSuccess);
        }];
    },

    onClose: function () {
        cleverapps.crossPromo.saveShownMarkTime();
        MenuControlButton.updateAttention();
    },

    onResize: function () {
        this._super();
        if (!this.closed && this.wideMode !== cleverapps.resolution.mode) {
            this.wideMode = cleverapps.resolution.mode;
            this.rebuildWindow(this.createContent());
            this.windowTitle.show();
        }
    },

    createPromotionView: function (promotion) {
        const styles = cleverapps.styles.CrossPromoWindow.promotionView;
        const image = new cc.Sprite(promotion.image || bundles[promotion.bundleName].urls.image);
        const button = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            text: Messages.get("Play"),
            onClicked: this.onPressed.bind(this, promotion)
        });

        button.setAlignment(styles.button.position);
        image.addChild(button);

        return image;
    },

    createContent: function () {
        const styles = cleverapps.styles.CrossPromoWindow;

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("CrossPromo.text"),
            cleverapps.styles.FONTS.CROSSPROMO_TEXT
        );

        const cols = connector.platform.oneOf(connector.YANDEX) ? 2 : 1;

        const promotions = this.promotions.slice();

        const rows = [];
        while (promotions.length > 0) {
            rows.push(new cleverapps.Layout(promotions.splice(0, cols).map(this.createPromotionView.bind(this)), {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            }));
        }

        const layout = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        const scrollView = new cleverapps.UI.ScrollView(layout, {
            childrenVisibility: false,
            direction: cleverapps.UI.ScrollView.Vertical,
            mouseScroll: true
        });

        if (cleverapps.resolution.mode === cleverapps.resolution.mode.HORIZONTAL && connector.info.isMobile) {
            scrollView.setContentSize2(styles.scrollView.width, styles.scrollView.mobileHorizontalHeight);
        } else {
            scrollView.setContentSize2(styles.scrollView.width, styles.scrollView.height);
        }
        scrollView.setAnchorPoint(0.5, 0.5);
        scrollView.scrollTo(cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);

        return new cleverapps.Layout([text, scrollView], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.content.margin,
            padding: styles.content.padding
        });
    },

    onPressed: function (promotion) {
        connector.platform.switchGame(promotion.link, promotion.payload, (error) => {
            if (error) {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.STATS.PROMO + (error === connector.ERRORS.SWITCH_GAME.CANCEL ? "cancel" : "error")}_${promotion.id}`);
            }
        });

        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PROMO + promotion.id);
        this.close();
    },

    listBundles: function (promotions) {
        const bundles = promotions.map((promotion) => promotion.bundleName);

        bundles.push("crosspromo");

        return bundles;
    },

    loadImages: function (promotions, onSuccess) {
        const toLoad = promotions.filter((promotion) => promotion.imageURL);

        onSuccess = cleverapps.wait(toLoad.length, onSuccess);

        toLoad.forEach((promotion) => {
            cc.loader.loadImg(promotion.imageURL, (err, image) => {
                if (image) {
                    promotion.image = image;
                }

                onSuccess();
            });
        });
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUTTON_PROMO_TEXT: {
        size: 10,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    CROSSPROMO_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.CrossPromoWindow = {
    promotionView: {
        button: {
            width: 240,
            height: 100,
            position: {
                x: { align: "center" },
                y: { align: "bottom", dy: 30 }
            }
        }
    },
    margin: 30,
    scrollView: {
        width: 1220,
        height: [1600, 900, 900],
        mobileHorizontalHeight: 1300
    },

    content: {
        margin: 20,
        padding: {
            top: 10
        }
    },

    window: {
        padding: {
            x: 0,
            top: 25,
            bottom: 30
        }
    }
};
